/**
 * 파일 정보
 */
export default interface FileMeta {
  /**
   * 파일 이름
   */
  name: string;
  /**
   * 확장자
   */
  ext: string;
  file: File;
}


/**
 * 파일 이름을 meta interface로 변환합니다.
 * @param fileName 변환하고자 하는 파일 이름
 * @returns FileMeta
 */
export const convertFileToFileMeta = (file: File) => {
  return {
    name: file.name.replace(/\.[^/.]+$/, ""),
    ext: file.name.replace(/[\S ]*\./, ""),
    file: file
  } as FileMeta;
}